module.exports = __webpack_public_path__ + "static/img/14.ab71b1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/14.jpg
// module id = WKXi
// module chunks = 15